/* eslint-disable @typescript-eslint/camelcase */

export default class Event {
  id = 0;

  title = '';

  description = '';

  price = 0;

  base_price = 0;

  allow_single_session_purchase = false;

  allow_waitlist = false;

  allow_staff_selection = false;

  spots_remaining = 0;

  enable_dynamic_pricing = false;

  single_session_price = 0;

  participant_count = 0;

  privacy = false;

  url = '';

  path = '';

  admin_path = '';

  status = '';

  // image: Image;
  // image_dimensions: Image;
  //   event_type: EventType;
  //   purchased_registrations: Registration[];
  //   registrations: Registration[];
  session_ids: Array<string> = [];

  schedule_type = '';

  // schedules: Schedule[];
  exclusive_membership_ids: Array<number> = [];

  product_type = '';
}
